







import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  name: 'LinkButton',
  setup(_props, context) {
    const { ctaLink } = context.attrs;

    // @ts-ignore
    const { $store } = useNuxtApp();

    return {
      computedCtaLink: computed(() => {
        if ($store.getters.isExp_038_goodBetterBestVariant && ctaLink === 'shop/products/fightcamp') {
          return 'shop';
        }
        return ctaLink;
      }),
    };
  },
});
